module.exports = __webpack_public_path__ + "media/images/talent/case3-img01-9162463bec5a61fac9e3c9183c08e3c1.png";